<script type="text/javascript">
	import MenuItem from "../FlyoutMenu/MenuItem.svelte";
	import Button, { Group, GroupItem, Label, Icon } from "@smui/button";
	import "./DownloadButton.scss";

	// The button text.
	export let text = "Download";

	// The download file name.
	export let filename = "download.json";

	// This function must return a valid blob url.
	export let content = () => {
		return "";
	};

	// The data format
	export let formatMode;

	let filename_safe = filename.substr(0, filename.indexOf("."));

	let onClick = () => {
		let link = content();
		const selector = "#id_" + filename_safe;
		const a = document.querySelector(selector);
		console.log(selector, a);
		a.href = link;
		a.click();
	};
</script>

<div class='download-button-container'>
	<Button on:click={onClick} download={filename} color="secondary" variant="unelevated" >
		<Icon class="material-icons">save_alt</Icon>
		<Label>{text}</Label>
	</Button>
	<a id={"id_"+filename_safe} href="javascript:;" download={filename} style="display:none;">&nbsp;</a>
</div>
